// GeneralHelper.js
export default class GeneralHelper {
    /**
     * Darken a hex color by a given fraction (0-1)
     * @param {string} hex - Hex color (e.g. #fff, #ffffff)
     * @param {number} fraction - Fraction to darken (e.g. 0.15 for 15%)
     * @returns {string} Darkened hex color
     */
    static darkenHex(hex, fraction) {
      hex = hex.replace(/^#/, "");

      if (hex.length === 3) {
        hex = hex
          .split("")
          .map(c => c + c)
          .join("");
      }

      const num = parseInt(hex, 16);
      let r = (num >> 16) & 0xff;
      let g = (num >> 8) & 0xff;
      let b = num & 0xff;

      r = Math.max(0, Math.min(255, Math.floor(r * (1 - fraction))));
      g = Math.max(0, Math.min(255, Math.floor(g * (1 - fraction))));
      b = Math.max(0, Math.min(255, Math.floor(b * (1 - fraction))));

      return (
        "#" +
        r.toString(16).padStart(2, "0") +
        g.toString(16).padStart(2, "0") +
        b.toString(16).padStart(2, "0")
      );
    }

    /**
     * Lighten a hex color by a given fraction (0-1)
     * @param {string} hex - Hex color
     * @param {number} fraction - Fraction to lighten
     * @returns {string} Lightened hex color
     */
    static lighten(hex, fraction) {
      hex = hex.replace(/^#/, "");

      if (hex.length === 3) {
        hex = hex
          .split("")
          .map(c => c + c)
          .join("");
      }

      const num = parseInt(hex, 16);
      let r = (num >> 16) & 0xff;
      let g = (num >> 8) & 0xff;
      let b = num & 0xff;

      r = Math.max(0, Math.min(255, Math.floor(r + (255 - r) * fraction)));
      g = Math.max(0, Math.min(255, Math.floor(g + (255 - g) * fraction)));
      b = Math.max(0, Math.min(255, Math.floor(b + (255 - b) * fraction)));

      return (
        "#" +
        r.toString(16).padStart(2, "0") +
        g.toString(16).padStart(2, "0") +
        b.toString(16).padStart(2, "0")
      );
    }

    /**
   * Shift a hex color by adding a fixed amount to RGB channels
   * @param {string} hex - Hex color (#RRGGBB)
   * @param {number} rShift - Red channel shift
   * @param {number} gShift - Green channel shift
   * @param {number} bShift - Blue channel shift
   * @returns {string} Shifted hex color
   */
  static shift(hex, rShift = 0, gShift = 0, bShift = 0) {
    hex = hex.replace(/^#/, "");

    if (hex.length === 3) {
      hex = hex
        .split("")
        .map(c => c + c)
        .join("");
    }

    const num = parseInt(hex, 16);
    let r = (num >> 16) & 0xff;
    let g = (num >> 8) & 0xff;
    let b = num & 0xff;

    // Shift and clamp
    r = Math.max(0, Math.min(255, r + rShift));
    g = Math.max(0, Math.min(255, g + gShift));
    b = Math.max(0, Math.min(255, b + bShift));

    return (
      "#" +
      r.toString(16).padStart(2, "0") +
      g.toString(16).padStart(2, "0") +
      b.toString(16).padStart(2, "0")
    );
  }

    static isNearWhite(hex) {
				hex = hex.replace('#','');
				if (hex.length === 3) hex = hex.split('').map(c => c+c).join('');
				const r = parseInt(hex.slice(0,2), 16);
				const g = parseInt(hex.slice(2,4), 16);
				const b = parseInt(hex.slice(4,6), 16);
				return r > 245 && g > 245 && b > 245
    }

  /**
   * Compare two semantic versions.
   * @param {string} v1 - First version string (e.g. "1.8.3")
   * @param {string} v2 - Second version string (e.g. "1.8.4")
   * @returns {number} 1 if v1 > v2, -1 if v1 < v2, 0 if equal
   */
  static compareVersions(v1, v2) {
    const p1 = (v1 || '').split('.').map(Number);
    const p2 = (v2 || '').split('.').map(Number);
    const length = Math.max(p1.length, p2.length);
    for (let i = 0; i < length; i++) {
      const n1 = isNaN(p1[i]) ? 0 : p1[i];
      const n2 = isNaN(p2[i]) ? 0 : p2[i];
      if (n1 > n2) return 1;
      if (n1 < n2) return -1;
    }
    return 0;
  }
}
